export const FreeEditorToolbarConfig = {
  options: ["inline"]
};
